/** Строковые value из таблицы discount_types (Laravel). */
export const DISCOUNT_TYPE_VALUE = {
	CASHIER_MANUAL: 'cashier_manual',
	AUTO_DISH: 'auto_dish',
	AUTO_CHEQUE: 'auto_cheque',
	MANUAL_CHEQUE: 'manual_cheque',
	FIRST_ORDER: 'first_order',
	PROMOCODE_GENERATED: 'promocode_generated',
	PROMOCODE_FIXED: 'promocode_fixed',
	MANUAL_DISH: 'manual_dish',
	MENU_PROMO: 'menu_promo',
	BUY_GET: 'buy_get',
	GIFT: 'gift',
	DELIVERY_DISCOUNT: 'delivery_discount',
}

const ID_TO_VALUE = {
	1: DISCOUNT_TYPE_VALUE.CASHIER_MANUAL,
	2: DISCOUNT_TYPE_VALUE.AUTO_DISH,
	3: DISCOUNT_TYPE_VALUE.AUTO_CHEQUE,
	4: DISCOUNT_TYPE_VALUE.MANUAL_CHEQUE,
	5: DISCOUNT_TYPE_VALUE.FIRST_ORDER,
	6: DISCOUNT_TYPE_VALUE.PROMOCODE_GENERATED,
	7: DISCOUNT_TYPE_VALUE.PROMOCODE_FIXED,
	8: DISCOUNT_TYPE_VALUE.MANUAL_DISH,
	9: DISCOUNT_TYPE_VALUE.MENU_PROMO,
	10: DISCOUNT_TYPE_VALUE.BUY_GET,
	11: DISCOUNT_TYPE_VALUE.GIFT,
	13: DISCOUNT_TYPE_VALUE.DELIVERY_DISCOUNT,
}

export function resolveDiscountTypeValue(ruleOrType) {
	if (ruleOrType && typeof ruleOrType === 'object') {
		if (ruleOrType.discount_type_value) {
			return String(ruleOrType.discount_type_value)
		}
		const typeId = ruleOrType.discount_type ?? ruleOrType.discount_type_id
		return ID_TO_VALUE[Number(typeId)] || null
	}
	return ID_TO_VALUE[Number(ruleOrType)] || null
}

export function isAutoPromoDiscountType(ruleOrType) {
	const value = resolveDiscountTypeValue(ruleOrType)
	return (
		value === DISCOUNT_TYPE_VALUE.MENU_PROMO ||
		value === DISCOUNT_TYPE_VALUE.BUY_GET ||
		value === DISCOUNT_TYPE_VALUE.GIFT
	)
}

export function isFixedDiscount(discount) {
	return discount?.entity_type === 'discount_fixed'
}
